module.exports = __webpack_public_path__ + "img/WolfgangKohne_140x140_rund.31d2a0e7.jpg";